import {Value} from "./value";
import {UnitType} from "./unitType";

export class Percent extends Value {
    constructor(value: number) {
        super(value, UnitType.PERCENT);
    }
}
